import { motion } from "framer-motion";
import { CHAPTERS } from "@/lib/data";

export const Chapters = () => (
  <section id="how-it-works" className="mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32" data-testid="chapters-section">
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8 }}
      className="mb-14"
    >
      <p className="mb-4 font-mono-x text-xs uppercase tracking-[0.28em] text-amber-400">How It Works</p>
      <h2 className="font-display max-w-2xl text-3xl font-bold tracking-tight text-amber-50 sm:text-5xl">
        From first clip to <span className="italic text-amber-400">January takedown.</span>
      </h2>
    </motion.div>

    <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
      {CHAPTERS.map((c, i) => (
        <motion.div
          key={c.num}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, delay: i * 0.12 }}
          whileHover={{ y: -6 }}
          className={`relative overflow-hidden rounded-2xl border border-amber-500/15 bg-[#0B1D14]/80 p-7 transition-colors hover:border-amber-500/40 ${i % 2 === 1 ? "lg:mt-10" : ""}`}
          data-testid={`chapter-${c.num}`}
        >
          <span className="font-display pointer-events-none absolute -right-3 -top-6 text-[7rem] font-black italic leading-none text-amber-500/10">
            {c.num}
          </span>
          <span className="font-mono-x text-xs tracking-[0.3em] text-amber-400">{c.num}</span>
          <h3 className="font-display mt-4 text-xl font-semibold text-amber-50">{c.title}</h3>
          <p className="mt-3 text-sm leading-relaxed text-emerald-100/70">{c.body}</p>
        </motion.div>
      ))}
    </div>
  </section>
);
